/* ==========================================================================
   Leyuze — davranış katmanı
   Bağımlılık yok. Her modül kendi elemanı yoksa sessizce çıkar.
   ========================================================================== */

(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  // Arapçada sayfa sağdan sola: yatay kaydırma değeri (scrollLeft) negatif ilerler
  var RTL = document.documentElement.dir === 'rtl';
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ----------------------------------------------------------------------
     Header: duyuru şeridini geçince üste sabitlenir, zemini beyaza döner.
     Referans: sayfa başında şeffaf (hero üstünde beyaz yazı), kaydırınca
     beyaz zemin + siyah yazı.
     ---------------------------------------------------------------------- */

  function initHeader() {
    var header = $('#site-header');
    if (!header) return;
    var ann = $('.announcement');
    var ticking = false;

    function threshold() { return ann && !ann.hidden ? ann.offsetHeight : 0; }
    function update() {
      header.classList.toggle('is-fixed', window.scrollY > threshold());
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function initAnnouncement() {
    var btn = $('[data-announcement-close]');
    var bar = $('.announcement');
    if (!btn || !bar) return;
    btn.addEventListener('click', function () {
      bar.hidden = true;
      document.documentElement.style.setProperty('--ann-h', '0px');
    });
  }

  /* ----------------------------------------------------------------------
     Mobil yan menü (modazehrada.com düzeni): soldan kayarak açılır, arkası
     karartılır; MENÜ / KATEGORİLER sekmeleri, alt öğeli kategori + ile açılır
     ---------------------------------------------------------------------- */

  function initMenu() {
    var toggle = $('[data-menu-toggle]');
    var drawer = $('#mobile-menu');
    if (!toggle || !drawer) return;
    var close = $('[data-menu-close]', drawer);
    var hideTimer = 0;

    function isOpen() { return drawer.classList.contains('is-open'); }
    function setOpen(open, keepFocus) {
      clearTimeout(hideTimer);
      toggle.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        drawer.hidden = false;
        // Görünür olduktan bir kare sonra sınıf: kayma geçişi çalışsın
        requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-open'); }); });
      } else {
        drawer.classList.remove('is-open');
        hideTimer = setTimeout(function () { drawer.hidden = true; }, 300);
      }
      if (!keepFocus) (open ? (close || drawer) : toggle).focus({ preventScroll: true });
    }
    // Arama ya da ülke paneli menünün içinden açılınca menü kapanır
    document.addEventListener('overlay:open', function () { if (isOpen()) setOpen(false, true); });
    toggle.addEventListener('click', function () { setOpen(!isOpen()); });
    if (close) close.addEventListener('click', function () { setOpen(false); });
    // Karartılmış alana dokununca kapanır
    drawer.addEventListener('click', function (e) { if (e.target === drawer) setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) setOpen(false);
    });

    var tabs = $$('[data-mnav-tab]', drawer);
    var body = $('.mnav__body', drawer);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (body) body.scrollTop = 0;
      });
    });

    $$('[data-mnav-toggle]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', String(open));
        var sub = document.getElementById(btn.getAttribute('aria-controls'));
        if (sub) sub.hidden = !open;
      });
    });
  }

  /* ----------------------------------------------------------------------
     Kaydırma ilerleme çizgisi — vitrinler ve mobil ürün galerisi
     ---------------------------------------------------------------------- */

  function bindProgress(scroller, bar) {
    if (!scroller || !bar) return;
    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      var visible = scroller.scrollWidth ? scroller.clientWidth / scroller.scrollWidth : 1;
      bar.style.setProperty('--w', Math.max(visible * 100, 8).toFixed(2) + '%');
      bar.style.setProperty('--p', max > 0 ? Math.min(1, Math.abs(scroller.scrollLeft) / max).toFixed(4) : 0);
      bar.hidden = max <= 1;
    }
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    return update;
  }

  function initRails() {
    $$('.rail-section').forEach(function (sec) {
      // Öneriler sonradan yüklenince initRails yeniden çağrılıyor; zaten
      // bağlı vitrinlere ikinci dinleyici eklenirse oklar iki adım atlar.
      if (sec.dataset.bound) return;
      sec.dataset.bound = '1';
      var rail = $('[data-rail]', sec);
      var prev = $('[data-rail-prev]', sec);
      var next = $('[data-rail-next]', sec);
      if (!rail) return;
      var update = bindProgress(rail, $('[data-rail-progress]', sec));

      function step(dir) {
        var card = rail.firstElementChild;
        var w = card ? card.getBoundingClientRect().width + 4 : rail.clientWidth / 2;
        var perView = Math.max(1, Math.floor(rail.clientWidth / w));
        rail.scrollBy({ left: (RTL ? -dir : dir) * w * perView, behavior: 'smooth' });
      }
      function arrows() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        var pos = Math.abs(rail.scrollLeft);
        if (prev) prev.disabled = pos <= 2;
        if (next) next.disabled = pos >= max;
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      rail.addEventListener('scroll', arrows, { passive: true });
      arrows();
      if (update) update();
    });

    var gallery = $('[data-gallery]');
    if (gallery) bindProgress(gallery, $('[data-gallery-progress]'));
  }

  /* ----------------------------------------------------------------------
     Koleksiyon: 2 / 4 yoğunluk anahtarı (tercih hatırlanır)
     ---------------------------------------------------------------------- */

  function initDensity() {
    var grid = $('[data-product-grid]');
    var buttons = $$('.coll-head__density button[data-density]');
    if (!grid || !buttons.length) return;
    var KEY = 'leyuze:density';

    function apply(v) {
      grid.dataset.density = v;
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.density === v)); });
      try { localStorage.setItem(KEY, v); } catch (e) { /* özel sekme */ }
    }
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) { /* yok say */ }
    if (saved === '2' || saved === '4') apply(saved);
    buttons.forEach(function (b) { b.addEventListener('click', function () { apply(b.dataset.density); }); });

    var sort = $('[data-auto-submit]');
    if (sort) sort.addEventListener('change', function () { sort.form.submit(); });
  }

  /* ----------------------------------------------------------------------
     Koleksiyon: sonsuz kaydırma. Izgaranın altı görünmeye yaklaşınca
     sonraki sayfa bölüm olarak (section_id) istenir, kartları eklenir.
     Ürüne gidip geri dönünce yüklenmiş kartlar ve kaydırma yeri
     sessionStorage'dan geri gelir.
     ---------------------------------------------------------------------- */

  function initInfiniteScroll() {
    var loader = $('[data-infinite]');
    var grid = $('[data-product-grid]');
    if (!loader || !grid || !window.fetch || !window.IntersectionObserver) return;
    var nav = $('[data-pagination]');
    if (nav) nav.hidden = true;
    var status = $('[data-infinite-status]', loader);
    var sectionId = loader.dataset.sectionId;
    var next = loader.dataset.nextUrl;
    var busy = false;
    var KEY = 'leyuze-infinite-v1';
    var observer;

    function finish() {
      if (observer) observer.disconnect();
      loader.remove();
    }

    // Geri tuşuyla dönüldüyse önceki durumu kur
    var navEntry = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { saved = null; }
    if (saved && navEntry && navEntry.type === 'back_forward' && saved.url === location.href) {
      grid.innerHTML = saved.html;
      next = saved.next;
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      requestAnimationFrame(function () { window.scrollTo(0, saved.y); });
      if (!next) { finish(); return; }
    }

    grid.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('a')) return;
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ url: location.href, html: grid.innerHTML, next: next, y: window.scrollY }));
      } catch (err) { /* depolama dolu ya da kapalı: geri dönünce ilk sayfa açılır */ }
    });

    function nearBottom() {
      return loader.getBoundingClientRect().top < window.innerHeight + 1200;
    }

    function load() {
      if (busy || !next) return;
      busy = true;
      if (status) status.hidden = false;
      var url = next + (next.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('[data-product-grid]');
          var frag = document.createDocumentFragment();
          if (incoming) Array.prototype.slice.call(incoming.children).forEach(function (el) { frag.appendChild(el); });
          if (window.leyuzeFx) window.leyuzeFx.convert(frag);
          grid.appendChild(frag);
          var nextLoader = doc.querySelector('[data-infinite]');
          next = nextLoader ? nextLoader.dataset.nextUrl : null;
          busy = false;
          if (status) status.hidden = true;
          // Gözcü hâlâ görünür alandaysa gözlemci yeniden tetiklenmez; sıradakini hemen iste
          if (!next) finish();
          else if (nearBottom()) setTimeout(load, 0);
        })
        .catch(function () {
          // Ağ hatası: bir sonraki kaydırmada yeniden dener
          busy = false;
          if (status) status.hidden = true;
        });
    }

    observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) load();
    }, { rootMargin: '0px 0px 1200px 0px' });
    observer.observe(loader);
    // Yedek: gözlemcinin geciktiği tarayıcılarda kaydırmada da kontrol et
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking || !next) return;
      ticking = true;
      setTimeout(function () { ticking = false; if (nearBottom()) load(); }, 150);
    }, { passive: true });
  }

  function initFilters() {
    var toggle = $('[data-filter-toggle]');
    var facets = $('#facets');
    if (!toggle || !facets) return;
    toggle.addEventListener('click', function () {
      var open = facets.hidden;
      facets.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* ----------------------------------------------------------------------
     Benzer ürünler: Shopify'ın öneri motorundan bölümü sunucuda çizdirip
     yerine koy, sonra vitrin davranışlarını bağla.
     ---------------------------------------------------------------------- */

  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (box) {
      var url = box.dataset.url;
      if (!url || !window.fetch) return;
      fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          box.innerHTML = fresh.innerHTML;
          initRails();
          initDragScroll(box);
          if (window.leyuzeFx) window.leyuzeFx.convert(box);
        }
      }).catch(function () { /* öneri yoksa bölüm boş kalır */ });
    });
  }

  /* ----------------------------------------------------------------------
     Ürün sayfası sekmeleri (Açıklama · Kargo ve İade · Ödeme)
     ---------------------------------------------------------------------- */

  function initTabs() {
    $$('[data-tabs]').forEach(function (box) {
      var tabs = $$('[role="tab"]', box);
      // Sayfa açılışında bütün sekmeler kapalı; açık sekmeye yeniden basınca kapanır
      function select(tab, keep) {
        if (!keep && tab && tab.getAttribute('aria-selected') === 'true') tab = null;
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          n.focus(); select(n, true);
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
     Ürün varyantı
     Renk seçilince galeri o rengin görsellerine döner; Renk + Beden
     kombinasyonuna göre variant id, fiyat ve buton durumu güncellenir.
     Temada varyant verisi [data-product-json] içinde gelir.
     ---------------------------------------------------------------------- */

  function formatTRY(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1] + ' ₺';
  }

  function initVariants() {
    var root = $('[data-product-root]');
    if (!root) return;

    // Renk ürünü daireleri: üzerine gelince/odaklanınca adını göster
    var colorLabel = $('[data-color-label]', root);
    if (colorLabel) {
      var own = colorLabel.textContent;
      $$('[data-color-name]', root).forEach(function (a) {
        var show = function () { colorLabel.textContent = a.dataset.colorName; };
        var reset = function () { colorLabel.textContent = own; };
        a.addEventListener('mouseenter', show);
        a.addEventListener('focus', show);
        a.addEventListener('mouseleave', reset);
        a.addEventListener('blur', reset);
      });
    }

    var label = $('[data-swatch-label]', root);
    var gallery = $('[data-gallery]', root);
    var colorImages = null;
    var ci = $('[data-color-images]', root);
    if (ci) { try { colorImages = JSON.parse(ci.textContent); } catch (e) { colorImages = null; } }

    $$('.option--swatch [data-option-selector]', root).forEach(function (input) {
      input.addEventListener('change', function () {
        if (label) label.textContent = input.value;
        var imgs = colorImages && colorImages[input.dataset.color];
        if (gallery && imgs && imgs.length) {
          gallery.innerHTML = imgs.map(function (u, i) {
            return '<div class="pdp__slide"><img src="' + u + '" alt="" loading="' + (i ? 'lazy' : 'eager') + '"></div>';
          }).join('');
          gallery.scrollLeft = 0;
        }
      });
    });

    var json = $('[data-product-json]', root);
    var idInput = $('[data-variant-id]', root);
    var button = $('[data-add-button]', root);
    var addLabel = $('[data-add-label]', root);
    var priceBox = $('.pdp__price', root);
    // Üstü çizili fiyatın ekran okuyucu etiketi; fiyat yeniden yazılınca kaybolmasın
    var regularLabelEl = priceBox && $('s .visually-hidden', priceBox);
    var regularLabel = regularLabelEl ? regularLabelEl.textContent : 'Liste fiyatı';
    if (!json || !idInput || !button) return;

    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    var strings = {
      add: button.dataset.addToCartLabel || 'Sepete Ekle',
      soldOut: button.dataset.soldOutLabel || 'Tükendi',
      unavailable: button.dataset.unavailableLabel || 'Bu kombinasyon mevcut değil',
      choose: button.dataset.chooseLabel || 'Beden seçin'
    };

    function current() {
      return $$('.option', root).map(function (fs) {
        var c = $('[data-option-selector]:checked', fs);
        return c ? c.value : null;
      });
    }
    function find(opts) {
      return variants.find(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      }) || null;
    }
    function update() {
      var secim = current();
      // Beden seçilmeden sepete eklenemesin: seçim yapılmayan seçenek varsa
      // buton kapalı kalır ve "Beden seçin" yazar.
      if (secim.some(function (o) { return o === null; })) {
        idInput.value = '';
        button.disabled = true;
        if (addLabel) addLabel.textContent = strings.choose;
        return;
      }
      var v = find(secim);
      if (!v) {
        idInput.value = '';
        button.disabled = true;
        if (addLabel) addLabel.textContent = strings.unavailable;
        return;
      }
      idInput.value = v.id;
      button.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? strings.add : strings.soldOut;
      if (priceBox) {
        priceBox.innerHTML = '<span data-cents="' + v.price + '">' + formatTRY(v.price) + '</span>' +
          (v.compare_at_price > v.price
            ? '<s><span class="visually-hidden">' + regularLabel + '</span><span data-cents="' + v.compare_at_price + '">' + formatTRY(v.compare_at_price) + '</span></s>'
            : '');
        if (window.leyuzeFx) window.leyuzeFx.convert(priceBox);
      }
      // "Sepette X ₺" (snippets/cart-offer): seçilen bedenin fiyatından, Shopify gibi hesapla
      var offer = $('[data-cart-offer]', root);
      if (offer) {
        var offerPrice = $('[data-cents]', offer);
        var net = v.price - Math.floor(v.price * Number(offer.dataset.pct) / 100);
        offerPrice.setAttribute('data-cents', net);
        offerPrice.textContent = formatTRY(net);
        if (window.leyuzeFx) window.leyuzeFx.convert(offer);
      }
      if (history.replaceState) {
        var url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
    }
    $$('[data-option-selector]', root).forEach(function (i) { i.addEventListener('change', update); });
    // Tek bedenli üründe (şal: "Standart") beden seçili gelir; buton açılsın
    if (current().every(function (o) { return o !== null; })) update();
  }


  /* ----------------------------------------------------------------------
     Ana sayfa görseli: "Video (yalnız mobil)" yalnız mobilde oynar;
     masaüstünde indirilmez bile (preload="none", başlatılmaz)
     ---------------------------------------------------------------------- */

  function initHeroVideo() {
    var videos = $$('[data-hero-video] video');
    if (!videos.length || !window.matchMedia) return;
    var mobile = window.matchMedia('(max-width: 999px)');

    // Oynatmayı dener; olmazsa video hazır olur olmaz yeniden dener.
    // (preload="none" olduğu için ilk play() çağrısında henüz veri olmayabiliyor;
    // iPhone düşük güç modunda ise tarayıcı isteği tümden reddediyor.)
    function oynat(v) {
      var p = v.play();
      if (!p || !p.catch) return;
      p.catch(function () {
        ['loadeddata', 'canplay', 'canplaythrough'].forEach(function (olay) {
          v.addEventListener(olay, function tekrar() {
            v.removeEventListener(olay, tekrar);
            if (mobile.matches) { var q = v.play(); if (q && q.catch) q.catch(function () {}); }
          });
        });
      });
    }

    // Video gerçekten oynamaya başlayınca görselin üstüne bindir (renk sıçraması
    // görünmesin diye yumuşak geçiş; bkz. components.css .hero__video-m).
    videos.forEach(function (v) {
      var kap = v.closest('[data-hero-video]') || v.parentElement;
      v.addEventListener('playing', function () { kap.classList.add('is-playing'); });
      v.addEventListener('emptied', function () { kap.classList.remove('is-playing'); });
      // HEVC kaynağını tarayıcı "oynatırım" deyip çözemezse (bazı Android
      // çözücüleri) HEVC'yi çıkarıp H.264 ile yeniden başlat.
      v.addEventListener('error', function () {
        var hevc = v.querySelector('source[data-hevc]');
        if (!hevc || !v.querySelector('source:not([data-hevc])')) return;
        hevc.remove();
        v.load();
        if (mobile.matches) oynat(v);
      }, true);
    });

    // Veri tasarrufu açıksa video indirilmez, ilk kare görseli kalır
    var tasarruf = navigator.connection && navigator.connection.saveData;

    // Video, ilk kare görseli (sayfanın en büyük öğesi, LCP) indikten sonra
    // istenir; iki dosya aynı anda bant genişliği paylaşıp görseli geciktirmesin.
    function gorselHazir(v, fn) {
      var kare = v.closest('.hero__media');
      kare = kare && kare.querySelector('picture img');
      if (!kare || kare.complete) return fn();
      kare.addEventListener('load', fn, { once: true });
      kare.addEventListener('error', fn, { once: true });
    }

    function sync() {
      if (tasarruf) return;
      videos.forEach(function (v) {
        if (mobile.matches) {
          v.muted = true;
          // Mobilde indirmeyi başlat: masaüstünde video gizli olduğu için
          // Liquid tarafında preload="none" kalıyor, veri boşa inmiyor.
          gorselHazir(v, function () {
            if (!mobile.matches) return;
            if (v.preload !== 'auto') { v.preload = 'auto'; v.load(); }
            oynat(v);
          });
        } else {
          v.pause();
        }
      });
    }
    if (mobile.addEventListener) mobile.addEventListener('change', sync);
    // Sayfa arka planda açıldıysa görünür olunca; iPhone düşük güç modunda
    // otomatik oynatma engellenirse ilk dokunuşta başlat
    document.addEventListener('visibilitychange', function () { if (!document.hidden) sync(); });
    window.addEventListener('touchstart', sync, { once: true, passive: true });
    sync();
  }

  /* ----------------------------------------------------------------------
     Paneller (arama, ülke/dil): ortak aç/kapat, odak ve Escape
     ---------------------------------------------------------------------- */

  function makeOverlay(el, opts) {
    var lastFocus = null;
    function open(e) {
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      document.dispatchEvent(new CustomEvent('overlay:open', { detail: el }));
      el.hidden = false;
      document.documentElement.classList.add('has-overlay');
      if (opts.onOpen) opts.onOpen();
    }
    function close() {
      if (el.hidden) return;
      el.hidden = true;
      if (opts.onClose) opts.onClose();
      if (!$$('[data-search-overlay], [data-localization], [data-zoom], [data-size-guide], [data-sal-offer], [data-video-modal]').some(function (o) { return !o.hidden; })) {
        document.documentElement.classList.remove('has-overlay');
      }
      if (lastFocus && document.contains(lastFocus) && lastFocus.offsetParent !== null) lastFocus.focus();
    }
    document.addEventListener('overlay:open', function (e) { if (e.detail !== el) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });
    // Panelin dışına (yarı saydam örtüye) tıklayınca kapanır
    el.addEventListener('click', function (e) { if (e.target === el) close(); });
    return { open: open, close: close };
  }

  /* ----------------------------------------------------------------------
     Arama paneli — yazdıkça sonuçlar (Section Rendering API, 250ms bekleme)
     ---------------------------------------------------------------------- */

  function initSearch() {
    var el = $('[data-search-overlay]');
    if (!el) return;
    var form = $('[data-search-form]', el);
    var input = $('[data-search-input]', el);
    var clear = $('[data-search-clear]', el);
    var suggest = $('[data-search-suggest]', el);
    var results = $('[data-search-results]', el);
    var timer = null, ctrl = null, lastTerm = '';

    var overlay = makeOverlay(el, {
      onOpen: function () {
        // Masaüstünde duyuru şeridi görünüyorsa panel onun altından başlar (referans)
        var ann = $('.announcement');
        var top = ann && !ann.hidden ? Math.max(0, ann.getBoundingClientRect().bottom) : 0;
        el.style.top = window.matchMedia('(min-width: 1000px)').matches ? top + 'px' : '';
        setTimeout(function () { input.focus(); input.select(); }, 30);
      }
    });
    $$('[data-search-open]').forEach(function (t) { t.addEventListener('click', overlay.open); });
    $$('[data-search-close]', el).forEach(function (t) { t.addEventListener('click', overlay.close); });

    function show(term) {
      if (ctrl) ctrl.abort();
      clear.hidden = !term;
      if (!term) {
        results.innerHTML = '';
        if (suggest) suggest.hidden = false;
        return;
      }
      ctrl = window.AbortController ? new AbortController() : null;
      var url = form.getAttribute('action') + '?q=' + encodeURIComponent(term) +
        '&type=product&options%5Bprefix%5D=last&section_id=search-overlay';
      results.setAttribute('aria-busy', 'true');
      fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-search-results-inner]');
          results.innerHTML = inner ? inner.outerHTML : '';
          if (window.leyuzeFx) window.leyuzeFx.convert(results);
          if (suggest) suggest.hidden = true;
          results.removeAttribute('aria-busy');
        })
        .catch(function () { /* yeni harf yazılınca önceki istek iptal edilir */ });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var term = input.value.trim();
        if (term === lastTerm) return;
        lastTerm = term;
        show(term);
      }, 250);
    });
    clear.addEventListener('click', function () {
      input.value = '';
      lastTerm = '';
      show('');
      input.focus();
    });
  }

  /* ----------------------------------------------------------------------
     Ürün görseli büyütme: tıklanan görsel beyaz tam ekranda, ekran
     genişliğinde; kaydırarak incelenir, tıklayınca ya da Esc ile kapanır
     ---------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------
     Ürün kartı, dokunmatik ekran: parmak hangi kartın üstündeyse (dokunup
     kaydırırken de) yalnız o kartta 2. görsel ve bedenler görünür; parmak
     kalkınca eski haline döner. Diğer kartlar değişmez; dokunuş eskisi gibi
     ürüne gider.
     ---------------------------------------------------------------------- */

  function initCardTouchPreview() {
    if (!window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var active = null, timer = 0;
    function clear() {
      if (active) active.classList.remove('is-active');
      active = null;
    }
    document.addEventListener('touchstart', function (e) {
      clearTimeout(timer);
      var card = e.target.closest && e.target.closest('.card');
      if (active && active !== card) clear();
      if (!card || e.touches.length > 1) return;
      active = card;
      card.classList.add('is-active');
    }, { passive: true });
    function end() {
      clearTimeout(timer);
      var card = active;
      timer = setTimeout(function () { if (active === card) clear(); }, 250);
    }
    document.addEventListener('touchend', end, { passive: true });
    document.addEventListener('touchcancel', end, { passive: true });
  }

  /* ----------------------------------------------------------------------
     Ürün videosu: ilk görseldeki "▶ Video" düğmesi ortada açılır pencerede
     oynatır (galeride video yok). Oynatıcı ancak tıklanınca yüklenir;
     kendiliğinden ve sonsuz döngüde oynar, pencere kapanınca silinir (video
     durur). Shopify'a yüklenen video <template>'ten, YouTube/Vimeo iframe.
     ---------------------------------------------------------------------- */

  function initProductVideo() {
    var modal = $('[data-video-modal]');
    var open = $('[data-video-open]');
    if (!modal || !open) return;
    var frame = $('[data-video-frame]', modal);
    var tpl = $('template[data-video-template]', modal);
    var overlay = makeOverlay(modal, {
      onOpen: function () { var c = $('[data-video-close]', modal); if (c) c.focus(); },
      onClose: function () { frame.innerHTML = ''; }
    });
    open.addEventListener('click', function () {
      frame.innerHTML = '';
      if (open.dataset.videoSrc) {
        var iframe = document.createElement('iframe');
        iframe.src = open.dataset.videoSrc;
        iframe.title = modal.getAttribute('aria-label') || '';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.setAttribute('allowfullscreen', '');
        frame.appendChild(iframe);
      } else if (tpl) {
        frame.appendChild(tpl.content.cloneNode(true));
        var video = $('video', frame);
        if (video) video.play().catch(function () { /* kullanıcı oynatır */ });
      }
      overlay.open();
    });
    $$('[data-video-close]', modal).forEach(function (b) { b.addEventListener('click', overlay.close); });
  }

  function initZoom() {
    var el = $('[data-zoom]');
    if (!el) return;
    var img = $('[data-zoom-img]', el);
    var overlay = makeOverlay(el, {
      onOpen: function () { el.scrollTop = 0; var c = $('[data-zoom-close]', el); if (c) c.focus({ preventScroll: true }); }
    });
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-zoom-src]');
      if (!t) return;
      img.src = t.getAttribute('data-zoom-src');
      overlay.open(e);
    });
    el.addEventListener('click', overlay.close);
  }

  /* ----------------------------------------------------------------------
     Beden tablosu paneli: bedenlerin yanındaki bağlantı sayfadan çıkmadan
     sağdan açılır (nour-hammour.com "Size Guide")
     ---------------------------------------------------------------------- */

  function initSizeGuide() {
    var el = $('[data-size-guide]');
    if (!el) return;
    var panel = $('.sg__panel', el);
    var overlay = makeOverlay(el, {
      onOpen: function () {
        if (panel) panel.scrollTop = 0;
        var c = $('[data-size-guide-close]', el);
        if (c) c.focus({ preventScroll: true });
      }
    });
    $$('[data-size-guide-open]').forEach(function (t) { t.addEventListener('click', overlay.open); });
    $$('[data-size-guide-close]', el).forEach(function (t) { t.addEventListener('click', overlay.close); });
  }

  /* ----------------------------------------------------------------------
     Şal önerisi: Sepete Ekle'ye basınca ürünün renginde şal varsa sorulur.
     "Şalı da ekle": ikisi birlikte eklenir, sepete gidilir. "Şalsız devam
     et": form her zamanki gibi gönderilir. Kapat/Esc: hiçbir şey eklenmez.
     ---------------------------------------------------------------------- */

  function initSalOffer() {
    var el = $('[data-sal-offer]');
    var form = $('#product-form');
    if (!el || !form) return;
    var addBtn = $('[data-sal-add]', el);
    var confirmed = false;
    var overlay = makeOverlay(el, {
      onOpen: function () { if (addBtn) addBtn.focus({ preventScroll: true }); }
    });

    form.addEventListener('submit', function (e) {
      if (confirmed) return;
      e.preventDefault();
      overlay.open();
    });
    // Geri tuşuyla önbellekten dönülünce yeniden sorulsun
    window.addEventListener('pageshow', function (e) { if (e.persisted) confirmed = false; });

    function submitWithout() {
      confirmed = true;
      overlay.close();
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }

    $$('[data-sal-close]', el).forEach(function (b) { b.addEventListener('click', overlay.close); });
    $$('[data-sal-skip]', el).forEach(function (b) { b.addEventListener('click', submitWithout); });
    if (addBtn) addBtn.addEventListener('click', function () {
      addBtn.disabled = true;
      var data = new FormData(form);
      // Renk başlıkta olmadığı için iki ürünün rengi de satır bilgisi olarak gider
      var mainProps = {};
      data.forEach(function (value, key) {
        var m = /^properties\[(.+)\]$/.exec(key);
        if (m && value) mainProps[m[1]] = value;
      });
      var salProps = {};
      if (el.dataset.salColor && el.dataset.colorKey) salProps[el.dataset.colorKey] = el.dataset.salColor;
      var items = [
        { id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1), properties: mainProps },
        { id: Number(el.dataset.variantId), quantity: 1, properties: salProps }
      ];
      fetch(el.dataset.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () { window.location.href = el.dataset.cartUrl; })
        // Şal eklenemezse (ör. stok bitti) ürün yalnız eklenir
        .catch(function () { addBtn.disabled = false; submitWithout(); });
    });
  }

  /* ----------------------------------------------------------------------
     Teslimat ülkesi paneli ve dil listesi (ayrı ayrı açılır)
     ---------------------------------------------------------------------- */

  function initLocalization() {
    // Ülkeyi ya da dili elle seçen ziyaretçiye konum önerisi bir daha sorulmaz
    // (panel, başlıktaki dil listesi, alt bilgi)
    $$('form[action$="/localization"]').forEach(function (f) {
      if (!f.closest('[data-geo]')) f.addEventListener('submit', rememberGeoChoice);
    });

    var el = $('[data-localization]');
    if (!el) return;
    var overlay = makeOverlay(el, {
      onOpen: function () { var c = $('[data-localization-close]', el); if (c) c.focus(); }
    });
    $$('[data-localization-open]').forEach(function (t) { t.addEventListener('click', overlay.open); });
    $$('[data-localization-close]', el).forEach(function (t) { t.addEventListener('click', overlay.close); });
  }

  // Başlıktaki bayrak · dil kodu ve para birimi: altında küçük liste. Dışarı
  // tıklayınca, Escape'le, odak listeden çıkınca, para birimi seçilince ya da
  // bir panel açılınca kapanır.
  function initHeaderDropdowns() {
    $$('[data-dropdown-toggle]').forEach(function (btn) {
      var menu = document.getElementById(btn.getAttribute('aria-controls'));
      if (!menu) return;
      function setOpen(open) {
        menu.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
      }
      btn.addEventListener('click', function () { setOpen(menu.hidden); });
      menu.addEventListener('click', function (e) {
        if (!e.target.closest('[data-currency-option]')) return;
        setOpen(false);
        btn.focus();
      });
      document.addEventListener('click', function (e) {
        if (!menu.hidden && !menu.contains(e.target) && !btn.contains(e.target)) setOpen(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || menu.hidden) return;
        setOpen(false);
        btn.focus();
      });
      menu.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !menu.contains(e.relatedTarget) && e.relatedTarget !== btn) setOpen(false);
      });
      document.addEventListener('overlay:open', function () { setOpen(false); });
    });
  }

  /* ----------------------------------------------------------------------
     Konum önerisi. Shopify ülkeyi IP'den, dili tarayıcıdan tespit eder
     (/browsing_context_suggestions.json). Seçili ülke ya da dil farklıysa
     ortada küçük bir kutu açılır (snippets/geo-suggest); kutu önerilen
     dilde yazılır. Tarayıcı dili mağazada varsa (İngilizce, Arapça, Almanca)
     o önerilir; yoksa (Fransızca, İtalyanca…) ve Türkçe de bilmiyorsa
     İngilizce. Ziyaretçi zorla yönlendirilmez; cevabı (evet, hayır, kapat
     ya da elle dil/ülke seçimi) 30 gün hatırlanır.
     ---------------------------------------------------------------------- */

  var GEO_KEY = 'leyuze-geo-v1';
  var GEO_AUTO_KEY = 'leyuze-geo-ulke-v1';

  // Arama motoru botlarına ülke değiştirtme: Google Türkiye dışından tarıyor,
  // yoksa Türkçe sayfaları yurt dışı fiyatıyla görürdü.
  function botMu() {
    return /bot|crawl|spider|slurp|bingpreview|facebookexternalhit|lighthouse|headless/i
      .test(navigator.userAgent || '');
  }

  function rememberGeoChoice() {
    try { localStorage.setItem(GEO_KEY, JSON.stringify({ t: Date.now() })); } catch (e) { /* özel pencere */ }
  }

  function initGeoSuggest() {
    var el = $('[data-geo]');
    var cfgEl = $('[data-geo-config]');
    if (!el || !cfgEl || !window.fetch) return;
    if (window.Shopify && window.Shopify.designMode) return;

    function load(storage, key) {
      try { return JSON.parse(window[storage].getItem(key) || 'null'); } catch (e) { return null; }
    }

    var answered = load('localStorage', GEO_KEY);
    if (answered && Date.now() - answered.t < 30 * 864e5) return;

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    // Aynı oturumda her sayfada yeniden sormamak için yanıt sessionStorage'da
    var ctx = cfg.country + '|' + cfg.language;
    var cached = load('sessionStorage', GEO_KEY);
    if (cached && cached.ctx === ctx) {
      show(cached.data);
      return;
    }

    var url = cfg.root.replace(/\/?$/, '/') + 'browsing_context_suggestions.json' +
      '?country%5Benabled%5D=true&country%5Bexclude%5D=' + encodeURIComponent(cfg.country) +
      '&language%5Benabled%5D=true&language%5Bexclude%5D=' + encodeURIComponent(cfg.language);
    fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        try { sessionStorage.setItem(GEO_KEY, JSON.stringify({ ctx: ctx, data: data })); } catch (e) { /* özel pencere */ }
        show(data);
      })
      .catch(function () { /* öneri alınamazsa kutu açılmaz */ });

    function show(data) {
      var parts = (data && data.suggestions && data.suggestions[0] && data.suggestions[0].parts) || {};
      var has = Object.prototype.hasOwnProperty;
      var country = parts.country && parts.country.handle !== cfg.country &&
        has.call(cfg.currencies, parts.country.handle) ? parts.country : null;
      var language = parts.language && parts.language.handle !== cfg.language &&
        has.call(cfg.endonyms, parts.language.handle) ? parts.language.handle : null;

      // Shopify yalnız tarayıcının ilk dili mağazada varsa dil önerir.
      // Türkçe sayfada, Türkçe bilmeyen ziyaretçiye tarayıcı dillerinden
      // mağazada olan ilkini, yoksa İngilizceyi öner.
      var ownLanguage = false;
      if (!language && cfg.language === 'tr') {
        var browser = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''])
          .map(function (l) { return String(l).slice(0, 2).toLowerCase(); });
        if (browser[0] && browser.indexOf('tr') === -1) {
          language = browser.filter(function (l) { return has.call(cfg.endonyms, l); })[0] ||
            (has.call(cfg.endonyms, 'en') ? 'en' : null);
          ownLanguage = !!language;
        }
      }
      if (!country && !language) return;
      // Ülke zaten otomatik ayarlandıysa kutu sadece dil için açılır
      if (country && load('localStorage', GEO_AUTO_KEY) && !language) return;

      var lang = language || cfg.language;
      var S = cfg.strings[lang] || cfg.strings.en;

      function countryName(code, shopifyName) {
        // Shopify adı kendi önerdiği dilde ya da sayfanın dilinde verir;
        // dili biz önerdiysek adı tarayıcıdan o dilde al
        if (!ownLanguage && shopifyName) return shopifyName;
        try { return new Intl.DisplayNames([lang], { type: 'region' }).of(code) || shopifyName || code; } catch (e) { return shopifyName || code; }
      }
      function currencyLabel(code) {
        try {
          var symbol = new Intl.NumberFormat('en', { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' })
            .formatToParts(0).filter(function (p) { return p.type === 'currency'; })[0].value;
          return symbol && symbol !== code ? code + ' (' + symbol + ')' : code;
        } catch (e) { return code; }
      }
      var endonym = language ? cfg.endonyms[language] : '';
      var values = {
        country: country ? countryName(country.handle, country.name) : '',
        currency: country ? currencyLabel(cfg.currencies[country.handle]) : '',
        language: lang === 'ar' ? endonym : endonym.charAt(0).toLocaleUpperCase(lang) + endonym.slice(1)
      };
      function fill(template) {
        // Yön yalıtımı: Arapça cümledeki "EUR (€)" gibi değerlerin sırası bozulmasın
        return template.replace(/\{(\w+)\}/g, function (m, k) { return '⁨' + values[k] + '⁩'; });
      }

      var lines = [];
      if (country && language) lines.push(fill(S.language_line));
      if (country) lines.push(fill(cfg.currencies[country.handle] === 'TRY' ? S.try_line : S.fx_line));
      lines.push(S.hint);

      el.lang = lang;
      el.dir = lang === 'ar' ? 'rtl' : 'ltr';
      $('[data-geo-title]', el).textContent = fill(country ? S.title_country : S.title_language);
      $('[data-geo-text]', el).textContent = lines.join(' ');
      $('[data-geo-yes]', el).textContent = S.yes;
      $('[data-geo-stay]', el).textContent = S.no;
      $('.geo__close', el).setAttribute('aria-label', S.close);

      var countryInput = $('[data-geo-country]', el);
      var languageInput = $('[data-geo-language]', el);
      if (country) { countryInput.value = country.handle; countryInput.disabled = false; }
      if (language) { languageInput.value = language; languageInput.disabled = false; }

      // TESLİMAT ÜLKESİ SORULMADAN AYARLANIR.
      // Gurbetçi müşteriler siteyi Türkçe geziyor; ülke seçilmeyince TL fiyatı
      // görüp ödeme adımında Almanya'yı seçtiklerinde fiyat sıçrıyordu.
      // Ülke baştan doğru seçilince gezerken gördükleri fiyat ödemede de aynı.
      // Dil değiştirilmiyor: Türkçe kalmak isteyen Türkçe kalıyor.
      // Ziyaretçi üstteki ülke/para birimi seçicisinden her zaman değiştirebilir.
      if (country && !botMu() && !load('localStorage', GEO_AUTO_KEY)) {
        try { localStorage.setItem(GEO_AUTO_KEY, JSON.stringify({ c: country.handle, t: Date.now() })); } catch (e) { /* özel pencere */ }
        if (languageInput) { languageInput.disabled = true; }   // yalnız ülke
        $('form', el).submit();
        return;
      }

      function close() {
        rememberGeoChoice();
        el.hidden = true;
      }
      $$('[data-geo-no]', el).forEach(function (b) { b.addEventListener('click', close); });
      $('form', el).addEventListener('submit', rememberGeoChoice);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !el.hidden && !document.documentElement.classList.contains('has-overlay')) close();
      });
      el.hidden = false;
    }
  }

  /* ----------------------------------------------------------------------
     Vitrinleri fareyle tutup kaydırma (yalnız fare; dokunmatikte tarayıcı
     zaten kaydırıyor). Bırakınca hızına göre biraz daha kayar, sonra en
     yakın karta oturur. Sürüklemeden sonra karttaki bağlantı açılmaz.
     ---------------------------------------------------------------------- */

  function initDragScroll(root) {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    $$('[data-rail], [data-drag-scroll], .table-scroll', root).forEach(function (el) {
      if (el.dataset.dragBound) return;
      el.dataset.dragBound = '1';
      el.setAttribute('data-drag-scroll', '');
      // Tablolar kart dizisi değil: bırakınca bir karta oturmaz, olduğu yerde kalır
      var free = el.classList.contains('table-scroll');

      var down = false, moved = false, suppressClick = false;
      var startX = 0, startLeft = 0, lastX = 0, lastT = 0, velocity = 0, raf = 0, pointerId = null;

      function snap() {
        el.style.scrollSnapType = '';
        if (free) return;
        var pad = parseFloat(getComputedStyle(el).scrollPaddingLeft) || 0;
        var box = el.getBoundingClientRect();
        var best = null, bestDist = Infinity;
        Array.prototype.forEach.call(el.children, function (child) {
          var r = child.getBoundingClientRect();
          var pos = RTL ? r.right - box.right + el.scrollLeft + pad
                        : r.left - box.left + el.scrollLeft - pad;
          var d = Math.abs(pos - el.scrollLeft);
          if (d < bestDist) { bestDist = d; best = pos; }
        });
        if (best !== null) el.scrollTo({ left: best, behavior: 'smooth' });
      }

      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (raf) { cancelAnimationFrame(raf); raf = 0; el.style.scrollSnapType = ''; }
        down = true; moved = false; suppressClick = false;
        startX = lastX = e.clientX; startLeft = el.scrollLeft;
        lastT = performance.now(); velocity = 0; pointerId = e.pointerId;
      });
      el.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved) {
          if (Math.abs(dx) < 6) return;
          moved = true; suppressClick = true;
          el.classList.add('is-dragging');
          try { el.setPointerCapture(pointerId); } catch (err) { /* eski tarayıcı */ }
        }
        e.preventDefault();
        el.scrollLeft = startLeft - dx;
        var now = performance.now(), dt = now - lastT;
        if (dt > 0) velocity = 0.8 * ((e.clientX - lastX) / dt) + 0.2 * velocity;
        lastX = e.clientX; lastT = now;
      });
      function end() {
        if (!down) return;
        down = false;
        if (!moved) return;
        // Tıklamalar ve üzerine gelme hemen geri gelsin; süzülürken kart
        // hizalaması (scroll-snap) kapalı kalsın, yoksa kaymayı keser
        el.classList.remove('is-dragging');
        el.style.scrollSnapType = 'none';
        var v = -velocity * 16;
        if (performance.now() - lastT > 80) v = 0;
        (function glide() {
          v *= 0.92;
          if (Math.abs(v) < 0.6) { raf = 0; snap(); return; }
          el.scrollLeft += v;
          raf = requestAnimationFrame(glide);
        })();
      }
      el.addEventListener('pointerup', end);
      el.addEventListener('pointercancel', end);
      el.addEventListener('lostpointercapture', end);
      el.addEventListener('click', function (e) {
        if (suppressClick) { e.preventDefault(); e.stopPropagation(); suppressClick = false; }
      }, true);
      el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }


  /* ----------------------------------------------------------------------
     Tahmini yerel fiyat. Ödeme altyapısı tek para birimi (TRY) desteklediği
     için Shopify'ın kendi dönüşümü açılamıyor. [data-cents] tutarları
     gösterim para biriminde "125 €" olarak, yukarı yuvarlanmış gösterilir,
     not görünür; ödeme TL alınır. Gösterim para birimi: başlıktan seçilen
     TL/EUR/USD (aynı teslimat ülkesinde geçerli, layout'taki satır içi betik
     okur), yoksa teslimat ülkesinin para birimi. Uluslararası pazardaki TL
     fiyata 10 € zaten ekli (migration/sync_intl_prices.py). Kur:
     open.er-api.com (12 saat önbellek), ulaşılamazsa temaya gömülü yedek
     (snippets/fx-rates).
     ---------------------------------------------------------------------- */

  var CURRENCY_KEY = 'leyuze-currency-v1';

  function initCurrency() {
    var FX = window.LeyuzeFx;
    if (!FX || !FX.currency) return;
    var rates = (FX.snapshot && FX.snapshot.rates) || null;
    var KEY = 'leyuze-fx-v1';
    var numberLocale = FX.locale === 'ar' ? 'ar-u-nu-latn' : (FX.locale || 'tr');
    var requested = false;

    function format(cents) {
      var rate = rates && rates[FX.currency];
      if (!rate) return null;
      // Yukarı yuvarla (kuruş hatası tam sayıyı bir üste atmasın diye önce kuruşa)
      var value = Math.ceil(Math.round(cents * rate) / 100);
      try {
        return new Intl.NumberFormat(numberLocale, { style: 'currency', currency: FX.currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(value);
      } catch (e) {
        try {
          return new Intl.NumberFormat(numberLocale, { style: 'currency', currency: FX.currency, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(value);
        } catch (e2) { return value + ' ' + FX.currency; }
      }
    }

    // Yeni gelen içerik (sonsuz kaydırma, arama, öneriler) sunucudan TL gelir
    function convert(root) {
      if (FX.currency === 'TRY' || !rates) return;
      $$('[data-cents]', root).forEach(function (el) {
        if (el.dataset.try === undefined) el.dataset.try = el.textContent.trim();
        var local = format(Number(el.dataset.cents));
        if (!local) return;
        // Seçilen kur tek başına yazılır ("≈" ve altında TL tutarı yok);
        // ödemenin TL alındığını ürün ve sepet sayfasındaki not söyler
        var text = local;
        if (el.dataset.fromTemplate) text = el.dataset.fromTemplate.replace('%s', text);
        el.textContent = text;
      });
      $$('[data-fx-note]', root).forEach(function (n) { n.hidden = false; });
    }

    // Başka para birimine geçerken önce sunucudaki TL yazısına dön
    function restore(root) {
      $$('[data-cents]', root).forEach(function (el) {
        if (el.dataset.try === undefined) return;
        el.textContent = el.dataset.try;
      });
      $$('[data-fx-note]', root).forEach(function (n) { n.hidden = true; });
    }

    function refreshRates() {
      if (requested || FX.currency === 'TRY' || !window.fetch) return;
      var cached = null;
      try { cached = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { cached = null; }
      if (cached && cached.rates && cached.rates[FX.currency]) {
        rates = cached.rates;
        if (cached.t && Date.now() - cached.t < 12 * 3600 * 1000) return;
      }
      requested = true;
      fetch('https://open.er-api.com/v6/latest/TRY')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.rates || !d.rates[FX.currency]) return;
          rates = d.rates;
          try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), rates: d.rates })); } catch (e) { /* özel pencere */ }
          restore(document);
          convert(document);
        })
        .catch(function () { /* yedek kurla devam */ });
    }

    function markCurrent() {
      $$('[data-currency-option]').forEach(function (b) {
        if (b.dataset.currencyOption === FX.currency) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
    }

    function setCurrency(code) {
      if (!/^(TRY|EUR|USD)$/.test(code) || code === FX.currency) return;
      FX.currency = code;
      document.documentElement.setAttribute('data-currency', code);
      try { localStorage.setItem(CURRENCY_KEY, JSON.stringify({ code: code, country: FX.country })); } catch (e) { /* özel pencere */ }
      markCurrent();
      restore(document);
      if (FX.currency !== 'TRY') {
        var cachedRates = null;
        try { cachedRates = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { cachedRates = null; }
        if (cachedRates && cachedRates.rates && cachedRates.rates[code]) rates = cachedRates.rates;
        convert(document);
        refreshRates();
      }
    }

    window.leyuzeFx = { convert: convert };

    $$('[data-currency-option]').forEach(function (b) {
      b.addEventListener('click', function () { setCurrency(b.dataset.currencyOption); });
    });
    markCurrent();

    if (FX.currency === 'TRY') return;
    refreshRates();
    convert(document);
  }

  /* ----------------------------------------------------------------------
     Sepet: adet değişince formu gönder
     ---------------------------------------------------------------------- */

  /* Başlıktaki sepet adedi ("Sepet (2)" ve mobildeki kırmızı yuvarlak). Sayfa
     geri tuşuyla tarayıcı önbelleğinden dönünce sunucudaki adet eski kalır;
     o durumda sepet yeniden okunur. */
  function setCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    $$('[data-cart-badge]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : count;
      el.hidden = count === 0;
    });
  }

  function initCartCount() {
    var link = $('.header__cart');
    if (!link || !window.fetch) return;
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      fetch(link.getAttribute('href') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (cart) { setCartCount(cart.item_count); })
        .catch(function () { /* adet sunucudaki gibi kalır */ });
    });
  }

  function initCart() {
    $$('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.value === '' || Number(input.value) < 0) input.value = 0;
        input.form.submit();
      });
    });
  }

  /* ----------------------------------------------------------------------
     Sepet: sözleşme onayı
     Kutu işaretli değilken yalnız "Ödemeye Geç" engellenir; adet
     güncellemesi ve "Sepeti Güncelle" çalışmaya devam eder. Onay metni
     tarayıcı saatiyle attributes[Sözleşme onayı] alanına yazılır.
     ---------------------------------------------------------------------- */

  function initCartConsent() {
    var box = $('[data-cart-consent-box]');
    if (!box || !box.form) return;
    var value = $('[data-cart-consent-value]');
    var error = $('[data-cart-consent-error]');

    box.addEventListener('change', function () {
      if (value) value.value = box.checked ? value.dataset.value + ' · ' + new Date().toLocaleString('tr-TR') : '';
      if (box.checked && error) error.hidden = true;
    });

    box.form.addEventListener('submit', function (e) {
      var submitter = e.submitter || document.activeElement;
      if (box.checked || !submitter || submitter.name !== 'checkout') return;
      e.preventDefault();
      if (error) error.hidden = false;
      box.focus();
    });
  }

  function init() {
    initAnnouncement();
    initHeader();
    initCurrency();
    initMenu();
    initSearch();
    initLocalization();
    initHeaderDropdowns();
    initGeoSuggest();
    initSizeGuide();
    initSalOffer();
    initHeroVideo();
    initZoom();
    initProductVideo();
    initCardTouchPreview();
    initRails();
    initDragScroll();
    initDensity();
    initInfiniteScroll();
    initFilters();
    initRecommendations();
    initTabs();
    initVariants();
    initCart();
    initCartCount();
    initCartConsent();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
